var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClosedsurveyi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1654_1998)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1654_1998",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 12,
    height: 12
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0H0V12H12V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1654_1998)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.25002 4.00002L4.00002 8.25M4 4L8.25002 8.25",
    stroke: "black",
    strokeWidth: 1.275,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5 1.66891C4.23543 1.24349 5.0893 1 6 1C8.7614 1 11 3.23857 11 6C11 8.7614 8.7614 11 6 11C3.23857 11 1 8.7614 1 6C1 5.0893 1.24349 4.23543 1.66891 3.5",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1654_1998"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClosedsurveyi);
export default __webpack_public_path__ + "static/media/closedsurveyi.71aae72d9b457a579d0bbd1b43893c7a.svg";
export { ForwardRef as ReactComponent };